import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/shared/global';
import { Client } from 'src/app/shared/models/client';

@Component({
  selector: 'app-user-intro',
  templateUrl: './user-intro.component.html',
  styleUrls: ['./user-intro.component.scss']
})
export class UserIntroComponent implements OnInit {

  source: string = 'userForm';
  client: Client = {} as Client;
  constructor(private router: Router, private global: Global) { }

  ngOnInit(): void {
  }
  // redirectEduCategoriesPage(): void {
  //   this.getEducationalLessons();
  // }
  // back(): void {
  //   this.router.navigate(['/'], { queryParams: { org: this.global.orgID } });
  // }
  // getEducationalLessons() {
  //   console.log(this.formService.getRequestObject());
  //   console.log('this.formService.userObjectForm', this.formService.userObjectForm);
  //   console.log('this.formService.userObjectForm.value.firstName', this.formService.userObjectForm.value.firstName);
  //   this.client = this.formService.mappingFromUserObject(this.client);
  //   this.formService.updateClientForm(this.client);
  //   this.userService.post(Global.BASE_URL + Global.GET_EDUCATIONAL_LESSONS, this.formService.getRequestObject())
  //     .subscribe(resp => {
  //       console.log(resp);
  //       this.global.getEduLessonObj = resp;
  //       console.log('')
  //       this.global.userName = this.formService.userObjectForm.value.firstName;
  //       // this.global.getEduLessonObj = JSON.parse(this.global.getEduLessonObj);
  //       this.router.navigate(['/lesson-categories'], { queryParams: { org: this.global.orgID } });

  //     })
      
  // }

}
